export { default as SubscriptionFormViews } from './SubscriptionFormViews'
export { default as SubscriptionPriceSummary } from './SubscriptionPriceSummary'
export { default as LoadingView } from './LoadingView'

export const SIGNUP_VIEWS = {
  loading: 'loading',
  details: 'details',
  form: 'form',
  success: 'success',
  cardForm: 'newCard',
  addressForm: 'newAddress',
}
